<ng-container *ngIf="localItems; else loader">
    <div class="dropdown-wrapper" [class.minimized]="minimized">
        <button
            mat-button
            [matMenuTriggerFor]="menu"
            class="dropdown-button"
            [matTooltip]="this._capitalLetterType + (selectedLocalItem?.name ? ': ' + selectedLocalItem?.name : '')">
            <div class="row-spacebetween">
                <mat-icon class="dropdown-icon">{{ this.matIcon }}</mat-icon>

                <div *ngIf="!minimized" class="dropdown-content multine-ellipsis">
                    {{ selectedLocalItem?.name || 'Loading ' + _capitalLetterType + 's' }}
                </div>
                <mat-icon *ngIf="!minimized">arrow_drop_down</mat-icon>
            </div>
        </button>

        <mat-menu #menu="matMenu" class="menu sfl-selector-menu">
            <h5 class="list-menu-title">
                {{ this._capitalLetterType }}
            </h5>

            <div *ngIf="searchable" class="search-container" (click)="$event.stopPropagation()">
                <mat-icon class="search-icon">search</mat-icon>
                <input
                    class="search-input"
                    type="text"
                    placeholder="Search..."
                    [value]="searchTerm"
                    (input)="onSearchInput($event)"
                    (keydown)="onSearchKeydown($event)" />
            </div>

            <div *ngIf="searchable && totalCount !== null" class="count-label">
                Showing {{ localItems?.length }} of {{ totalCount }}
            </div>

            <mat-divider></mat-divider>

            <div class="items-scroll-container">
                <ng-container *ngFor="let item of filteredItems">
                    <button mat-menu-item (click)="onSelectionChanged(item)">
                        <div class="row-spacebetween gapped menu-item-general">
                            <div class="menu-item-name row-spacebetween">
                                <mat-icon
                                    iconPositionEnd
                                    *ngIf="item.matIcon"
                                    class="smaller-icon no-margin"
                                    matTooltip="Master Workspace"
                                    >{{ item.matIcon }}
                                </mat-icon>
                                <span class="text">
                                    {{ item.name }}
                                </span>
                            </div>

                            <mat-icon
                                iconPositionEnd
                                *ngIf="item.id === selectedLocalItem?.id"
                                class="menu-check no-margin"
                                color="primary"
                                >check
                            </mat-icon>
                        </div>
                    </button>
                </ng-container>
                <div *ngIf="filteredItems?.length === 0" class="empty-state">No {{ _type }}s found</div>
                <button
                    *ngIf="totalCount !== null && filteredItems?.length < totalCount"
                    mat-menu-item
                    class="load-more-btn"
                    (click)="handleLoadMore($event)">
                    <mat-icon class="smaller-icon">expand_more</mat-icon>
                    Load more ({{ filteredItems?.length }} of {{ totalCount }})
                </button>
            </div>

            <mat-divider></mat-divider>

            <button mat-menu-item (click)="handleCreateNewItem($event)" class="bold menu-item-general">
                <mat-icon class="smaller-icon">add</mat-icon>
                New {{ this._capitalLetterType }}
            </button>
            <!-- <button mat-menu-item class="bold menu-item-general">
<mat-icon class="smaller-icon">person_add</mat-icon>
Invite
</button> -->
            <button mat-menu-item class="bold menu-item-general" (click)="handleSettingsClick($event)">
                <mat-icon class="smaller-icon">settings</mat-icon>
                {{ this._capitalLetterType }} settings
            </button>
        </mat-menu>
    </div>
</ng-container>

<ng-template #loader>Loading...</ng-template>
